// All or portions of this file Copyright © 2019 Amazon Web Services, Inc. or its affiliates or licensors.
// All rights reserved. For full license terms and conditions, please see the LICENSE file at the root of
// this distribution (the "License") or go to https://content.sumerian.amazonaws.com/engine/latest/license.txt.
// All use of the software is governed by the License. All materials are made available on an "AS IS" BASIS, WITHOUT
// WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. Do not remove or modify any license notices.
import AbstractTransitionState from '../../animationpack/state/AbstractTransitionState';

/**
 * A two state transition that freezes the starting state at its current position and blends that over time with a target state. The target
 *        state moves forward in time during the blend as normal.
 */
class FrozenTransitionState extends AbstractTransitionState {
  constructor() {
    super();
  }

  /**
   * Update this state using the current global time.
   * @param {number} globalTime the current global time.
   */
  update(globalTime) {
    super.update(globalTime);

    // update only the target state - the source state is frozen
    if (this._targetState) {
      this._targetState.update(globalTime);
    }
  }

  /**
   * Post update. If the state has no more clips and no end transition, this will clear this state from the layer.
   */
  postUpdate() {
    // update only the B state - the first is frozen
    if (this._targetState) {
      this._targetState.postUpdate();
    }
  }

  /**
   * Resets the clips to start at given time
   * @param {number} globalTime
   */
  resetClips(globalTime) {
    super.resetClips(globalTime);
    this._targetState.resetClips(globalTime);
  }

  shiftClipTime(shiftTime) {
    super.shiftClipTime(shiftTime);
    this._targetState.shiftClipTime(shiftTime);
  }
}

export default FrozenTransitionState;
